var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSpecialists(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1441 10C13.0541 9.99098 12.9459 9.99098 12.8468 10C10.7027 9.92785 9 8.16911 9 6.00451C9 3.79481 10.7838 2 13 2C15.2072 2 17 3.79481 17 6.00451C16.991 8.16911 15.2883 9.92785 13.1441 10Z",
    stroke: "#696969",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59677 13.56C11.0249 11.73 14.9927 11.73 17.4032 13.56C19.5323 15.17 19.5323 17.81 17.4032 19.43C15.9174 20.56 13.8475 20.9961 11.911 20.7381M7.44141 17.9995L8.43141 18.9895L10.5614 17.0195M11.911 20.7381C12.1039 20.5314 12.2748 20.3041 12.42 20.06C12.79 19.46 13 18.75 13 18C13 15.79 11.21 14 9 14C6.79 14 5 15.79 5 18C5 18.75 5.21 19.46 5.58 20.06C6.27 21.22 7.54 22 9 22C10.1528 22 11.1871 21.5137 11.911 20.7381Z",
    stroke: "#696969",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialists);
export default __webpack_public_path__ + "static/media/specialists.59515bde6bc8dc7d0f45db05622a966a.svg";
export { ForwardRef as ReactComponent };